import React, { PropTypes } from 'react';
import { icon } from './../../../../icons/icons';

const Text = (props) => {
    const { widget, actions } = props;

    const goBack = () => {
        actions.setWidgetTools('general');
    };

    return (
        <div className="option">
            <h3 className="option__header">{widget.type} Edit</h3>
            <div className="option__back" onClick={goBack} title="Back">{icon.backArrow()}</div>
        </div>
    );
};

Text.propTypes = {
    actions: PropTypes.object.isRequired,
    widget: PropTypes.shape({
        id: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        kind: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
    }).isRequired,
};

export default Text;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Tools/Widgets/Text/Text.jsx